import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "../constants/analytics";

/**
 * Sends a page_view on every route change (public, /auth/*, and private app routes).
 * Mounted after DocumentTitle so page_title is up to date.
 */
export default function AnalyticsTracker() {
  const location = useLocation();

  useLayoutEffect(() => {
    trackPageView(location.pathname, location.search);
  }, [location.pathname, location.search]);

  return null;
}
